<template>
  <monitorsForm :typeEndPoint="'schoolRoutesMonitorsForm'" :dataParams="{}"/>
</template>
<script>
import monitorsForm from '@/components/modules/schoolroutes/monitors/form'
export default {
  name: 'monitorsFormCreate',
  components: {
    monitorsForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/monitors/create.vue